import { useEffect, useState } from 'react'

type PerformanceNavigator = Navigator & {
  connection?: {
    saveData?: boolean
  }
  deviceMemory?: number
}

export function shouldReduceExperience() {
  if (typeof window === 'undefined') return true

  const browser = navigator as PerformanceNavigator
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches
  const savesData = browser.connection?.saveData === true
  const isCompactViewport = window.innerWidth < 1024
  const lowCoreDevice =
    typeof browser.hardwareConcurrency === 'number' &&
    browser.hardwareConcurrency <= 4
  const lowMemoryDevice =
    typeof browser.deviceMemory === 'number' && browser.deviceMemory <= 4

  return (
    prefersReducedMotion ||
    savesData ||
    isCompactViewport ||
    lowCoreDevice ||
    lowMemoryDevice
  )
}

export function useReducedExperience() {
  const [reduced, setReduced] = useState(shouldReduceExperience)

  useEffect(() => {
    const update = () => setReduced(shouldReduceExperience())
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    update()
    window.addEventListener('resize', update, { passive: true })
    motionQuery.addEventListener?.('change', update)

    return () => {
      window.removeEventListener('resize', update)
      motionQuery.removeEventListener?.('change', update)
    }
  }, [])

  return reduced
}
